import { render, staticRenderFns } from "./AddonsFileFilter.vue?vue&type=template&id=1af3dd04&"
import script from "./AddonsFileFilter.vue?vue&type=script&lang=js&"
export * from "./AddonsFileFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports